<template>
  <div>
    <VTextField
      v-model="internalValue"
      autocomplete
      outlined
      label="Email"
      name="username"
      :rules="[$store.state.rules.required,$store.state.rules.emailRules]"
    />
  </div>
</template>

<script>
  // Utilities
  import {
    mapMutations
  } from 'vuex'

  export default {
    name: 'UserName',

    mounted(){
      if(this.internalValue==="" && window.localStorage.getItem('username')){
        this.internalValue = window.localStorage.getItem('username')
        window.localStorage.removeItem('username')
      }
    },

    computed: {
      internalValue: {
        get () {
          return this.$store.state.username
        },
        set (val) {
          this.setUsername(val)
        }
      }
    },

    methods: {
      ...mapMutations(['setUsername'])
    }
  }
</script>
